// extracted by mini-css-extract-plugin
export default {"container":"container--UPb7t","squares":"squares--NKpJw","squareGif":"squareGif--j1qRM"};